import {Mapper} from '@s-ui/domain'

export class GetSellerRequestMapper extends Mapper {
  constructor({config, getSellerRequestFactory}) {
    super()

    this._config = config
    this._getSellerRequestFactory = getSellerRequestFactory

    const {PRIVATE_CONTRACT_ID} = this._config.get('dealer')
    this._privateContractId = PRIVATE_CONTRACT_ID
  }

  map = data => {
    const {contractId, userId} = data
    const hasUserId = Boolean(userId)
    const hasContractId = Boolean(contractId)
    const contractIdNumber = Number(contractId)

    const isPrivate = hasContractId ? contractIdNumber === this._privateContractId : hasUserId

    const isDealer = contractIdNumber > this._privateContractId

    const maybeContractId = hasContractId && String(contractId)
    const maybePrivateContractId = !hasContractId && hasUserId && String(this._privateContractId)

    return this._getSellerRequestFactory({
      contractId: maybeContractId || maybePrivateContractId,
      userId,
      isPrivate,
      isDealer
    })
  }
}
